@import 'styles/variables';

/** Following rule was disabled in order to facilitate introduction of eslint to the codebase (in other words, I didn't
want to bother fixing it) and not on purpose. If you know anything about this code, please fix */
/* stylelint-disable css-modules/no-global-scoped-selector */
:global .ant-skeleton-content ul.ant-skeleton-paragraph {
  li {
    background-color: $gray-20;
    border-radius: 4px;
    height: 16px;
    margin-top: 32px;
  }
  :nth-child(1) {
    margin-top: 5px;
    opacity: 1;
  }
  :nth-child(2) {
    opacity: 0.9;
  }
  :nth-child(3) {
    opacity: 0.8;
  }
  :nth-child(4) {
    opacity: 0.7;
  }
  :nth-child(5) {
    opacity: 0.5;
  }
  :nth-child(6) {
    opacity: 0.4;
  }
}
/* stylelint-enable css-modules/no-global-scoped-selector */

.animatedSkeleton {
  display: flex;
  justify-content: space-between;

  .titleColumn {
    display: flex;
    align-items: center;
    flex: 0 0 60%;
    min-width: 0;
    padding: 0px 10px;
  }

  .column {
    padding: 0px 0px;
    color: $gray-40;
    flex: 0 0 20%;
    min-width: 0;
  }
}
